import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all grades
export const fetchGrades = createAsyncThunk("grades/fetchGrades", async (params = {}) => {
  try {
    const page = typeof params === 'object' ? (params.page || 1) : params;
    const perPage = typeof params === 'object' ? (params.per_page || 10) : 10;
    const search = typeof params === 'object' ? (params.search || "") : "";
    const user = JSON.parse(localStorage.getItem("loggedUser"));
    const token = user?.token;
    const response = await axios.get(
      `${BASE_URL}/dashboard/grades?page=${page}&per_page=${perPage}&search=${encodeURIComponent(search)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept-Language": "ar",
        },
      }
    );
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || "Failed load data";
    throw new Error(message);
  }
});

// fetch settings grades (all grades without pagination)
export const fetchSettingsGrades = createAsyncThunk(
  "grades/fetchSettingsGrades",
  async (_, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.get(
        `${BASE_URL}/dashboard/settings/grades`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to load grades settings";
      return rejectWithValue(message);
    }
  }
);

// add grades
export const addGrades = createAsyncThunk(
  "grades/add",
  async (userData, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/grades`,
        userData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تمت الإضافة بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في إضافة الصف";
      return rejectWithValue(message);
    }
  }
);
// get grades record
export const gradesRecord = createAsyncThunk(
  "grades/gradesRecord",
  async (id, { rejectWithValue }) => {
    try {
    const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.get(`${BASE_URL}/dashboard/grades/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحميل بيانات الصف";
      return rejectWithValue(message);
    }
  }
);
// update grades
export const updateGrades = createAsyncThunk(
  "grades/updateGrades",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/grades/${id}/update`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تم التحديث بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحديث الصف";
      return rejectWithValue(message);
    }
  }
);
// delete grades
export const deleteGrades = createAsyncThunk(
  "grades/deleteGrades",
  async (id, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.delete(
        `${BASE_URL}/dashboard/grades/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في حذف الصف";
      return rejectWithValue(message);
    }
  }
);
const GradesSlice = createSlice({
  name: "grades",
  initialState: {
    grades: [],
    settingsGrades: [],
    record: null,
    meta: null,
    isLoading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGrades.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchGrades.fulfilled, (state, action) => {
        state.isLoading = false;
        state.meta = action.payload.meta;
        state.grades = action.payload;
      })
      .addCase(fetchGrades.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load data";
      })
      .addCase(addGrades.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addGrades.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(addGrades.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to add data";
      })
      .addCase(gradesRecord.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(gradesRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.record = action.payload.data;
      })
      .addCase(gradesRecord.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to add data";
      })
      .addCase(updateGrades.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateGrades.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(updateGrades.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          "Failed to update record";
      })
      .addCase(deleteGrades.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteGrades.fulfilled, (state, action) => {
        state.isLoading = false;

        // Remove from data array inside grades
        if (state.grades?.data) {
          state.grades.data = state.grades.data.filter(
            (record) => record.id !== action.meta.arg
          );
        }

        state.success = action.payload?.message || "Deleted successfully";
      })
      .addCase(deleteGrades.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          action.error?.message ||
          "Failed to delete grades";
      })
      .addCase(fetchSettingsGrades.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSettingsGrades.fulfilled, (state, action) => {
        state.isLoading = false;
        state.settingsGrades = action.payload.data;
      })
      .addCase(fetchSettingsGrades.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load settings grades";
      });
  },
});

export const { clearState } = GradesSlice.actions;
export default GradesSlice.reducer;
